import { Link, StoryElement, WithLazy } from "@quintype/components";
import get from "lodash/get";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { DfpComponent } from "../../ads/dfp-component";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import { getQueryParamsForArticleApi } from "../../utils/utils";
import {
  AuthorBox,
  AuthorDetails,
  BreadCrumbs,
  Headline,
  MultipleAuthorDetails,
  RelatedStories,
  StickyBar,
} from "../atoms";
import AdWrapper from "../atoms/AdWrapper";
import RecipeDetails from "./RecipeDetails";
import RecipeShare from "./RecipeShare";
import { StoryCard } from "./StoryCard";

import "./recipe.m.css";

const HeroVideo = ({ element, story }) => {
  return <WithLazy margin="50px">{() => <StoryElement element={element} story={story} loadIframeOnClick />}</WithLazy>;
};

const CardsWithAds = ({ story }) => {
  const counter = { ads: 0, paragraphs: 0 };
  return story?.cards?.map((card, index) => (
    <Fragment key={index}>
      <StoryCard key={card.id} card={card} story={story} counter={counter} />
    </Fragment>
  ));
};

const RecipeStoryTemplate = ({ story, adsConfig, template, params = {}, articleApi }) => {
  const recipePageTopAd = get(adsConfig, ["slots", "recipe_page_top_ad"], {});
  const authorBoxAttr = get(story, ["metadata", "story-attributes", "authorbox", "0"], "hide");
  const [heroVideoCard, setHeroVideoCard] = useState();
  const heroImageSlug = get(story, ["hero-image-s3-key"], "");
  const label = get(story, ["metadata", "story-attributes", "label", "0"], "");

  useEffect(() => {
    const heroVideoCard = story?.cards?.find(
      (card) => card?.metadata?.attributes?.cardtype?.[0]?.toLowerCase() === "hero"
    );
    const elements = get(heroVideoCard, ["story-elements"]);
    setHeroVideoCard(elements?.find((ele) => ele?.type === "jsembed" || ele?.type === "youtube-video"));
  }, []);
  return (
    <div styleName="recipe-wrapper">
      <div styleName={`${heroVideoCard || heroImageSlug ? "top-section" : "no-hero-top-section"}`}>
        <div styleName={`hero-image-section ${heroVideoCard || heroImageSlug ? "hero-video-image" : "no-hero-recipe"}`}>
          {heroVideoCard ? (
            <HeroVideo element={heroVideoCard} story={story} />
          ) : (
            <HeroImage story={story} aspectRatio={[[4, 3]]} isStoryPageImage={true} />
          )}
        </div>
        <div styleName="metadata meta-data-section">
          {label && <Label story={story} />}
          <Headline headline={story?.headline} />
          {story?.subheadline && <p styleName="sub-headline">{story?.subheadline}</p>}
          <AuthorDetails story={story} />
          <RecipeShare story={story} />
        </div>
      </div>
      <div styleName="bottom-section meta-data-section">
        <div styleName="lhs-wrapper">
          <RecipeDetails story={story} adsConfig={adsConfig} template={template} articleApi={articleApi} />
        </div>
        <div styleName="rhs-wrapper">
          <p styleName="method">Method</p>
          {story?.cards && <CardsWithAds story={story} />}
          <p styleName="tell-us-more">
            <Link href="/food" target="_self">
              Tell us more about your favourite dishes or recipes at food@gulfnews.com
            </Link>
          </p>
          <div styleName="icon-with-border">
            <div styleName="divider"></div>
            <SvgIconHandler type="tomato" width="32px" height="32px" />
            <div styleName="divider"></div>
          </div>

          {authorBoxAttr.toLowerCase() === "show" && (
            <div styleName="recipe-author-box">
              <AuthorBox story={story} />
            </div>
          )}
          {story.authors?.length > 3 && (
            <div styleName="multiple-authors">
              <MultipleAuthorDetails story={story} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

function Recipe({ story, storyIndex }) {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], {}));
  const params = getQueryParamsForArticleApi(currentPath);
  const template = get(story, ["story-template"], "");
  const adsConfig = get(qtState, ["config", "ads-config"], {});
  const articleApi = get(qtState, ["config", "articleApi"], {});
  const recipePageBodyAd = get(adsConfig, ["slots", "recipe_page_body_ad"], {});
  const recipePageBottomAd = get(adsConfig, ["slots", "recipe_page_bottom_ad"], {});
  const scrollRef = useRef();

  return (
    <>
      {!Object.keys(articleApi).length && <StickyBar story={story} scrollRef={scrollRef} storyIndex={storyIndex} />}
      <div className="story-grid" ref={scrollRef}>
        {!Object.keys(articleApi).length && <BreadCrumbs currentPath={story?.slug} />}
        <RecipeStoryTemplate
          story={story}
          adsConfig={adsConfig}
          template={template}
          params={params}
          articleApi={articleApi}
        />
        <div styleName="tags">
          {story.tags?.map((tag) => (
            <span>{tag.name}</span>
          ))}
        </div>
        <RelatedStories story={story} />
        <div styleName="recipe-ad-grid">
          <AdWrapper
            adStyleName="story-page-ad-slot"
            id={`${template}-bottom-ad`}
            path={recipePageBottomAd?.ad_unit}
            size={recipePageBottomAd?.sizes}
            viewPortSizeMapping={recipePageBottomAd?.view_port_size_mapping}
            isLhsAd={true}
          />
        </div>
      </div>
    </>
  );
}

export default Recipe;
